module.exports = __webpack_public_path__ + "static/media/charles.16b35c8b.jpg";